import * as types from '../MutationTypes';

const state = {
  queue: [],
  syncStatus: null, // TODO: Add actions and mutators for updating syncStatus
  schemaVersion: '2.0'
};

const getters = {
  queue: state => state.queue
};

const actions = {
  enqueue({ commit, state }, item) {
    commit(types.SYNC_ENQUEUE, item);
  },
  dequeue({ commit, state }, item) {
    commit(types.SYNC_DEQUEUE, item);
  },
  updateItem({ commit, state }, item) {
    commit(types.SYNC_DEQUEUE, item);
    commit(types.SYNC_ENQUEUE, item);
  },
  clearQueue({ commit, state }) {
    commit(types.SYNC_CLEAR);
  }
};

const mutations = {
  [types.SYNC_ENQUEUE](state, { item }) {
    // If item is not already enqueued, add it to the queue
    if (!state.queue.length || !state.queue.filter(queueItem => queueItem.itemId === item.itemId).length) {
      state.queue.push(item);
    }
  },
  [types.SYNC_DEQUEUE] (state, { item }) {
    if (state.queue.length) {
      state.queue = state.queue.filter(queueItem => queueItem.itemId !== item.itemId);
    }
  },
  [types.SYNC_CLEAR] (state) {
    state.queue = [];
  }
};


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/SyncQueue.js